// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.image-upload {
  display: flex;
  width: 100%;
  padding-right: 40px;
  margin-bottom: 3.9rem;
  font-size: 1.6rem;
  color: #292727;
}
.image-upload .image-container {
  height: 4rem;
  width: 4rem;
  border-radius: 4px;
  background-color: white;
  margin-right: 16px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06), 0px 1px 3px rgba(16, 24, 40, 0.1);
}
.image-upload .image-container img {
  height: 4rem;
  width: 4rem;
  padding: 4px;
  -o-object-fit: contain;
     object-fit: contain;
  max-width: unset;
}
.image-upload .upload-data {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.image-upload .upload-data .top {
  display: flex;
  align-items: center;
}
.image-upload .upload-data .top .file-name {
  margin-right: auto;
}
.image-upload .upload-data .top .upload-complete-icon {
  width: 1.4rem;
  height: 1.4rem;
}
.image-upload .upload-data .top .upload-complete-icon .cls-1 {
  fill: #ab3a72;
}
.image-upload .upload-data .top .remove-sticker-button {
  display: grid;
  place-content: center;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 100px;
  color: white;
  background-color: #9c9c9c;
  margin-left: 24px;
}
.image-upload .upload-data .top .remove-sticker-button-icon {
  width: 0.75em;
  height: 0.75em;
  fill: white;
}
.image-upload .upload-data .progress-bar {
  width: 100%;
  height: 0.5rem;
  background-color: #cacacb;
  border-radius: 100px;
  overflow: hidden;
  box-shadow: unset;
}
.image-upload .upload-data .progress-bar .progress-amount {
  height: 0.5rem;
  border-radius: 100px;
  background-color: #ab3a72;
}
.image-upload .upload-data .error-text {
  font-size: 1.2rem;
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Form/ImageUpload.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cDRU;ACSZ;AACE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iFAAA;AACJ;AACI;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;KAAA,mBAAA;EACA,gBAAA;AACN;AAGE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;AADN;AAGM;EACE,kBAAA;AADR;AAIM;EACE,aAAA;EACA,cAAA;AAFR;AAIQ;EACE,aDzBA;ACuBV;AAMM;EACE,aAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,yBDlDC;ECmDD,iBAAA;AAJR;AAMQ;EACE,aAAA;EACA,cAAA;EACA,WAAA;AAJV;AASI;EACE,WAAA;EACA,cAtEgB;EAuEhB,yBDrEW;ECsEX,oBAAA;EACA,gBAAA;EAEA,iBAAA;AARN;AAUM;EACE,cA9Ec;EA+Ed,oBAAA;EACA,yBD3DE;ACmDV;AAYI;EACE,iBAAA;EACA,UAAA;AAVN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n\n$progress-bar-height: 0.5rem;\n\n.image-upload {\n  display: flex;\n  width: 100%;\n  padding-right: 40px;\n  margin-bottom: 3.9rem;\n  font-size: 1.6rem;\n  color: $textColor;\n\n  .image-container {\n    height: 4rem;\n    width: 4rem;\n    border-radius: 4px;\n    background-color: white;\n    margin-right: 16px;\n    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06), 0px 1px 3px rgba(16, 24, 40, 0.1);\n\n    img {\n      height: 4rem;\n      width: 4rem;\n      padding: 4px;\n      object-fit: contain;\n      max-width: unset;\n    }\n  }\n\n  .upload-data {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n\n    .top {\n      display: flex;\n      align-items: center;\n\n      .file-name {\n        margin-right: auto;\n      }\n\n      .upload-complete-icon {\n        width: 1.4rem;\n        height: 1.4rem;\n\n        .cls-1 {\n          fill: $magenta;\n        }\n      }\n\n      .remove-sticker-button {\n        display: grid;\n        place-content: center;\n        width: 1.4rem;\n        height: 1.4rem;\n        border-radius: 100px;\n        color: white;\n        background-color: $shadow;\n        margin-left: 24px;\n\n        &-icon {\n          width: 0.75em;\n          height: 0.75em;\n          fill: white;\n        }\n      }\n    }\n\n    .progress-bar {\n      width: 100%;\n      height: $progress-bar-height;\n      background-color: $lightTextColor;\n      border-radius: 100px;\n      overflow: hidden;\n\n      box-shadow: unset;\n\n      .progress-amount {\n        height: $progress-bar-height;\n        border-radius: 100px;\n        background-color: $magenta;\n      }\n    }\n\n    .error-text {\n      font-size: 1.2rem;\n      color: red;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
